var React = require('react');

function MajorUniform (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.14 3.68l3.11 1.08a.76.76 0 0 1 .47.96.75.75 0 0 1-.71.5.73.73 0 0 1-.25 0l-2.76-1-4.41 6.17a.74.74 0 0 1-.49.29v9.56a.75.75 0 0 1-1.5 0v-10.7l-.6-.69-.64.72v10.67a.75.75 0 0 1-1.5 0v-9.57a.74.74 0 0 1-.45-.28L5 5.22 2.25 6.26a.73.73 0 0 1-.25 0 .75.75 0 0 1-.71-.5.76.76 0 0 1 .46-1l3.11-1.08 1.3-1.49h.06a1.09 1.09 0 0 1 .17-.13.72.72 0 0 1 .29-.06h10.64a.72.72 0 0 1 .36.13.9.9 0 0 1 .2.14l1.26 1.41zm-3.49-.16H8.34L12 7.64l3.65-4.12zm-9.4.86l.42-.48.06.1L11 8.76l-.89 1-3.86-5.38zm6.78 4.37l.88 1 3.84-5.37-.43-.48-4.29 4.85z","fill":"#000"}));
}

MajorUniform.defaultProps = {"width":"40","height":"40","viewBox":"0 0 24 24","fill":"none"};

module.exports = MajorUniform;

MajorUniform.default = MajorUniform;
